import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLine, FadeUp } from "./Reveal";
import { IMAGES } from "../constants/site";

const REGIONS = ["Napa Valley", "Sonoma County"];

export const Regions = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: imgRef, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section id="regions" data-testid="regions-section" className="py-28 md:py-40">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5 order-2 md:order-1">
            <FadeUp delay={0.2}>
              <div ref={imgRef} className="relative aspect-[3/4] overflow-hidden">
                <motion.img
                  src={IMAGES.aerial}
                  alt="Aerial view of vineyard rows and mountains in Napa Valley"
                  loading="lazy"
                  decoding="async"
                  style={{ y }}
                  className="absolute inset-0 w-full h-[114%] object-cover"
                />
              </div>
            </FadeUp>
          </div>

          <div className="md:col-span-7 order-1 md:order-2 md:pl-10">
            <FadeUp>
              <p className="text-[11px] tracking-[0.32em] uppercase text-[#B89B67] font-semibold mb-10">Where We Farm</p>
            </FadeUp>
            <h2 className="font-display font-light text-[#1A3626] text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-[13ch]">
              <MaskLine delay={0.1}>Napa &amp; Sonoma,</MaskLine>
              <MaskLine delay={0.22}>block by block.</MaskLine>
            </h2>
            <FadeUp delay={0.35} className="mt-10 max-w-[52ch]">
              <p className="text-base md:text-lg leading-relaxed text-[#2C2926]/80">
                Two counties, dozens of distinct appellations, no two farmed alike. We work the valley floor, the mountain benches, and the coastal hills, and we can tell you what each site asks of a farmer.
              </p>
            </FadeUp>

            <div className="mt-14 grid sm:grid-cols-2 gap-10">
              {REGIONS.map((region, i) => (
                <FadeUp key={region} delay={0.2 + i * 0.1}>
                  <div data-testid={`region-${region.toLowerCase().replace(/\s/g, "-")}`}>
                    <h3 className="font-display font-light text-3xl md:text-4xl text-[#1A3626] pb-5 border-b border-[#B89B67]/50">{region}</h3>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
